import {createRoot} from 'react-dom/client';
import styles from './styles.module.css';

type Items = {name: string; link: string; newTab: boolean}[];

const Footer = ({items}: {items: Items}) => {
    return (
        <>
            <svg
                width="100%"
                height="100"
                viewBox="0 0 100 20"
                preserveAspectRatio="none"
                style={{
                    display: 'block',
                }}
            >
                <path
                    d="M0,10 C20,0 40,20 60,10 C80,0 100,20 100,10 V20 H0Z"
                    fill="#F8F6E3"
                />
            </svg>
            <div className={styles.container}>
                <div className={styles.inner}>
                    <div className={styles.footerLinks}>
                        <b>Quick Links</b>
                        {items.map(item => (
                            <p key={item.name}>
                                <a
                                    href={item.link}
                                    target={item.newTab ? '_blank' : '_self'}
                                    className={styles.linkItem}
                                >
                                    {item.name}
                                </a>
                            </p>
                        ))}
                        <b>Contact Us</b>
                        <p className={styles.email}>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-envelope-fill"
                                viewBox="0 0 16 16"
                                style={{paddingRight: '4px'}}
                            >
                                <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414zM0 4.697v7.104l5.803-3.558zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586zm3.436-.586L16 11.801V4.697z" />
                            </svg>
                            {'deprescribing@uwa.edu.au'}
                        </p>
                        <p
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{
                                    paddingRight: '4px',
                                }}
                            >
                                <path
                                    d="M16 1C17.6569 1 19 2.34315 19 4C19 4.55228 18.5523 5 18 5C17.4477 5 17 4.55228 17 4C17 3.44772 16.5523 3 16 3H4C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H16C16.5523 21 17 20.5523 17 20V19C17 18.4477 17.4477 18 18 18C18.5523 18 19 18.4477 19 19V20C19 21.6569 17.6569 23 16 23H4C2.34315 23 1 21.6569 1 20V4C1 2.34315 2.34315 1 4 1H16Z"
                                    fill="#0F0F0F"
                                />
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M20.7991 8.20087C20.4993 7.90104 20.0132 7.90104 19.7133 8.20087L11.9166 15.9977C11.7692 16.145 11.6715 16.3348 11.6373 16.5404L11.4728 17.5272L12.4596 17.3627C12.6652 17.3285 12.855 17.2308 13.0023 17.0835L20.7991 9.28666C21.099 8.98682 21.099 8.5007 20.7991 8.20087ZM18.2991 6.78666C19.38 5.70578 21.1325 5.70577 22.2134 6.78665C23.2942 7.86754 23.2942 9.61999 22.2134 10.7009L14.4166 18.4977C13.9744 18.9398 13.4052 19.2327 12.7884 19.3355L11.8016 19.5C10.448 19.7256 9.2744 18.5521 9.50001 17.1984L9.66448 16.2116C9.76728 15.5948 10.0602 15.0256 10.5023 14.5834L18.2991 6.78666Z"
                                    fill="#0F0F0F"
                                />
                                <path
                                    d="M5 7C5 6.44772 5.44772 6 6 6H14C14.5523 6 15 6.44772 15 7C15 7.55228 14.5523 8 14 8H6C5.44772 8 5 7.55228 5 7Z"
                                    fill="#0F0F0F"
                                />
                                <path
                                    d="M5 11C5 10.4477 5.44772 10 6 10H10C10.5523 10 11 10.4477 11 11C11 11.5523 10.5523 12 10 12H6C5.44772 12 5 11.5523 5 11Z"
                                    fill="#0F0F0F"
                                />
                                <path
                                    d="M5 15C5 14.4477 5.44772 14 6 14H7C7.55228 14 8 14.4477 8 15C8 15.5523 7.55228 16 7 16H6C5.44772 16 5 15.5523 5 15Z"
                                    fill="#0F0F0F"
                                />
                            </svg>
                            <a
                                href="https://forms.office.com/r/ZmeuS9vMhu"
                                target="_blank"
                                rel="noreferrer"
                            >
                                Send us Feedback
                            </a>
                        </p>
                    </div>
                    <div>
                        <p>
                            {
                                'We acknowledge the Traditional Owners of Country throughout Australia and acknowledge their continuing connection to land, waters and community. We pay our respects to the people, the cultures and the Elders past and present.'
                            }
                        </p>
                        <p>
                            {
                                'The information and recommendations presented in this guideline represent the view of the guideline development group, based on careful consideration of the available evidence. It is not mandatory to apply the recommendations, and the guideline does not replace clinical judgment or the responsibility to make decisions tailored to the individual’s circumstances, in consultation with the person, their family, and/or carers.'
                            }
                        </p>
                    </div>
                </div>
                <div className={styles.logos}>
                    <img
                        className={styles.logo}
                        src="/images/UWA_FORMAL_LANDSCAPE_CMYK.webp"
                        alt="uwa-logo"
                    />
                    <img
                        className={styles.logo}
                        src="/images/WACHA-1.svg"
                        alt="wacha"
                    />
                    <img
                        className={styles.logo}
                        src="/images/COM.webp"
                        alt="com"
                    />
                </div>
            </div>
            <p className={styles.copyright}>
                {`Copyright © ${new Date().getFullYear()} Western Australia Centre for Health and Ageing and Centre for Optimisation of Medicines, The University of Western Australia`}
            </p>
        </>
    );
};

export default (items: Items) => {
    const domNode = document.getElementById('footer');
    if (domNode) {
        const root = createRoot(domNode);
        root.render(<Footer items={items} />);
    }
};
